import { Injectable } from '@angular/core';
import { BaseApiService } from './common/base-api.service';
import { API } from '../constants/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Rvsf {
  constructor(private baseApiService: BaseApiService) { }

  fetchRvsfDetailsByUrl(url: string) {
    // need to remove this for url base setup
    if (url.includes('localhost')) {
      url = 'autoloop.kiraninfosoft.in';
    }
    const params = {
      access_url: url,
    };
    return this.baseApiService.get(API.rvsf.details, params);
  }

  getVehicleDetails(vehicleNumber: number): Observable<any> {
    const params = { vehicle_number: vehicleNumber.toString() };
    return this.baseApiService.get(API.vehicles.vehicleRcDetails, params);
  }

  userLogout(): Observable<any> {
    const body = {}; // empty body as required
    return this.baseApiService.post(API.auth.logout, body);
  }
}
